import { render, staticRenderFns } from "./ModalVideoYouTube.vue?vue&type=template&id=275e9206&scoped=true&"
import script from "./ModalVideoYouTube.vue?vue&type=script&lang=js&"
export * from "./ModalVideoYouTube.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideoYouTube.vue?vue&type=style&index=0&id=275e9206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e9206",
  null
  
)

export default component.exports